import { render, staticRenderFns } from "./CannedResponsesTable.vue?vue&type=template&id=e6c0adc6&scoped=true"
import script from "./CannedResponsesTable.vue?vue&type=script&lang=js"
export * from "./CannedResponsesTable.vue?vue&type=script&lang=js"
import style0 from "./CannedResponsesTable.vue?vue&type=style&index=0&id=e6c0adc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c0adc6",
  null
  
)

export default component.exports